<template>
  <div>
    <el-dialog :title="this.isCreated ? '新增许愿槽配置' : '编辑许愿槽配置'" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="851px">
      <el-form ref="form" :model="form" label-width="220px" size="mini" style="margin-right: 50px">
        <el-form-item label="解锁条件（付费参与人数）">
          <el-input style="width: 120px" v-model="form.requiredPaidPlayerNumber"></el-input>
        </el-form-item>
        <el-form-item label="抽奖池：">
          <base-item-selector v-model="form.rewardPool"
            @updated="(value) => { this.form.rewardPool = value }"></base-item-selector>
        </el-form-item>
        <el-form-item label="保底奖励：">
          <base-item-selector v-model="form.guaranteedRewards"
            @updated="(value) => { this.form.guaranteedRewards = value }"></base-item-selector>
        </el-form-item>        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditWish2ActivityWishSlotDialog";

export default {
  data() {
    return {
      isCreated: false,
      form: {
        requiredPaidPlayerNumber: "", // 解锁条件（付费参与人数）
        rewardPool: [], // 抽奖池
        guaranteedRewards: [], // 保底奖励
      },
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.isCreated = value.isCreated;

    if (value.entry != null) {
      Object.assign(this.form, value.entry);
    }
  },

  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) { }
    },

    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) { }
    },

    save() {
      let requiredPaidPlayerNumber = this.form.requiredPaidPlayerNumber;
      if (typeof this.form.requiredPaidPlayerNumber === "string") {
       requiredPaidPlayerNumber = parseInt(this.form.requiredPaidPlayerNumber.trim());
      }
      if (isNaN(this.form.requiredPaidPlayerNumber) || requiredPaidPlayerNumber < 0) {
        return { errMsg: '"解锁条件（付费参与人数）"必须是一个非负整数' };
      }

      return {
        requiredPaidPlayerNumber: requiredPaidPlayerNumber,
        rewardPool: this.form.rewardPool,
        guaranteedRewards: this.form.guaranteedRewards,
      };
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },

    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>
